import { render, staticRenderFns } from "./shensu.vue?vue&type=template&id=5d4d324f"
import script from "./shensu.vue?vue&type=script&lang=js"
export * from "./shensu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports